import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authService } from "../../services/auth.service";
import { useAuth } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import "../../styles/app/VerifyPage.css";

const VerifyPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [verificationStatus, setVerificationStatus] = useState<
    "loading" | "success" | "failed"
  >("loading");
  const [message, setMessage] = useState("");
  const hasVerifiedRef = useRef(false);

  useEffect(() => {
    if (!token || hasVerifiedRef.current) {
      return;
    }

    hasVerifiedRef.current = true;

    const verifyAccount = async () => {
      if (!token) {
        setVerificationStatus("failed");
        setMessage("Token de verificación no proporcionado.");
        return;
      }

      try {
        const response = await authService.verifyAccount(token);

        if (response.success) {
          localStorage.setItem("isVerify", "true");
          setVerificationStatus("success");
          setMessage(
            "¡Tu cuenta ha sido verificada exitosamente! Haz clic para ir al Dashboard."
          );
        } else {
          localStorage.setItem("isVerify", "false");
          logout();
          setVerificationStatus("failed");
          setMessage(response.error || "Fallo la verificación de la cuenta.");
        }
      } catch (error) {
        localStorage.setItem("isVerify", "false");
        logout();
        setVerificationStatus("failed");
        setMessage("Ocurrió un error al verificar tu cuenta.");
        console.error("Error en la verificación:", error);
      }
    };

    verifyAccount();
  }, [token, navigate, logout]);

  const renderContent = () => {
    switch (verificationStatus) {
      case "loading":
        return (
          <div className="verification-status loading">
            <FontAwesomeIcon icon={faSpinner} spin size="3x" />
            <h2>Verificando tu cuenta...</h2>
            <p>Por favor, espera un momento.</p>
          </div>
        );
      case "success":
        return (
          <div className="verification-status success">
            <FontAwesomeIcon icon={faCheckCircle} size="3x" />
            <h2>¡Verificación Exitosa!</h2>
            <p>{message}</p>
            <button
              onClick={() => navigate("/customer/dashboard")}              className="btn-primary mt-4"
            >
              Ir al Dashboard
            </button>
          </div>
        );
      case "failed":
        return (
          <div className="verification-status failed">
            <FontAwesomeIcon icon={faTimesCircle} size="3x" />
            <h2>Fallo la Verificación</h2>
            <p>{message}</p>
            <button
              onClick={() => navigate("/login")}
              className="btn-primary mt-4"
            >
              Ir a Iniciar Sesión
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  return <div className="verify-page-container">{renderContent()}</div>;
};

export default VerifyPage;
